import { RiCloseLine } from '@remixicon/react';

import { Spinner } from '@spotify/confidence-core-react';

import {
  ImageAttachment,
  UploadingImageAttachment,
  attachmentKey,
} from '../../types';

import styles from './ImageAttachmentChip.module.css';

interface ImageAttachmentChipProps {
  attachment: ImageAttachment | UploadingImageAttachment;
  onRemove?: (key: string) => void;
}

export const ImageAttachmentChip = ({
  attachment,
  onRemove,
}: ImageAttachmentChipProps) => {
  const isUploading = attachment.kind === 'uploading-image';
  const previewUrl =
    attachment.kind === 'image'
      ? attachment.imageUri
      : attachment.localPreviewUrl;

  return (
    <div className={styles.root}>
      <div className={styles.thumbnailWrapper}>
        <img
          src={previewUrl}
          alt={attachment.fileName}
          className={styles.thumbnail}
        />
        {isUploading && (
          <div className={styles.loadingOverlay}>
            <Spinner size={16} />
          </div>
        )}
      </div>
      <span className={styles.fileName}>{attachment.fileName}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.removeButton}
          aria-label={`Remove ${attachment.fileName}`}
          onClick={() => onRemove(attachmentKey(attachment))}
         data-track-source-anchor="d196d1cc3b;image-attachment-chip-button">
          <RiCloseLine size={14} />
        </button>
      )}
    </div>
  );
};
